import { startLoginServer } from './login';
import { PublicAuthData } from './session';
import { Permission } from '~/util/types/permissions';
import { redirect } from '@tanstack/router-core';

export const tryAndCatchRedirect = async (fn: () => Promise<void>) => {
    try {
        await fn();
    } catch (error) {
        if (error instanceof Response && error.status === 307) {
            const location = error.headers.get('Location');
            if (location) {
                window.location.href = location;
            }
        }
    }
};

export const login = async () => {
    tryAndCatchRedirect(async () => {
        await startLoginServer();
    });
};

export const hasScope = (
    auth: Partial<PublicAuthData> | null,
    requiredScope: Permission | undefined,
) =>
    auth?.scopes &&
    ((!requiredScope &&
        auth.scopes.filter((scope) => scope != 'submission_priority').length >
            0) || // require at least one scope if none is specified
        (requiredScope && auth.scopes.includes(requiredScope))); // otherwise require specific scope

export const requireScope = (
    auth: Partial<PublicAuthData> | null,
    requiredScope: Permission | undefined,
) => {
    if (!hasScope(auth, requiredScope)) {
        throw redirect({
            to: '/',
            search: { showToast: 'insufficientPermissions' },
        });
    }
};

export const ensureAuth = (auth: Partial<PublicAuthData> | null) => {
    if (!auth?.access_token)
        throw redirect({ to: '/', search: { showToast: 'authRequired' } });
    else return { auth: auth as PublicAuthData };
};
